/** @typedef {import("./types").PricetypeQuantities} PricetypeQuantities */

/**
 * @param {number[]} pricetypes
 */
function expandPricetypeQuantities(pricetypes = []) {
  const map = new Map();

  pricetypes.forEach((pricetypeId) => {
    const total = map.get(pricetypeId) || 0;
    map.set(pricetypeId, total + 1);
  });

  return Array.from((map).entries())
    .map(([pricetypeId, quantity]) => ({ pricetypeId, quantity }));
}


/**
 * @param {PricetypeQuantities} pricetypeQuantities
 * @returns {number[]}
 */
function flattenPricetypeQuantities(pricetypeQuantities = []) {
  // eslint-disable-next-line arrow-body-style
  return pricetypeQuantities.reduce((previous, { pricetypeId, quantity }) => {
    return [...previous, ...Array(quantity).fill(pricetypeId)];
  }, []);
}


/**
 * @param {object} specialRequests
 * @returns {string}
 */
function stringifySpecialRequests(specialRequests = {}) {
  return Object.entries(specialRequests)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}


export {
  expandPricetypeQuantities,
  flattenPricetypeQuantities,
  stringifySpecialRequests,
};
